/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { message } from 'antd'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
import _ from 'lodash'
import { observer } from 'mobx-react'

import { TELEGRAM_LINK_CASE } from 'adv-lib/src/v2/constants/telegram-link-reward'

import useRootStore from '@store/useRootStore'

// css
import { Button } from '@styles/button.style'
import { TelegramContainer } from '@views/Popup/Telegram/index.style'
import DialogUtils from '@utils/dialog-utils'

const Telegram: React.FC = (): React.ReactElement => {
  const { userStore } = useRootStore()
  const { userGameOptions } = userStore

  let telegramChatId = userGameOptions.telegramChatId

  const onTelegramChatIdChange = (values: NumberFormatValues) => {
    telegramChatId = values.floatValue
  }

  const onClickConnectTelegramBtn = async () => {
    if (!_.isNumber(telegramChatId)) {
      message.info(['고유번호를 입력하세요.'])
      return
    }

    // setUserGameOption 은 실패 시 null 을 돌려준다 — 바로 필드에 접근하면 TypeError 가 난다
    const result = await userStore.setUserGameOption({ telegramChatId })
    if (!result) {
      message.info(['처리 중 오류가 발생했습니다.'])
      return
    }

    switch (result.linkCase) {
      case TELEGRAM_LINK_CASE.NEW:
      case TELEGRAM_LINK_CASE.CHANGED:
        DialogUtils.showCompletedTelegramSetting(result.popupImageUrl)
        break
      case TELEGRAM_LINK_CASE.ALREADY:
        message.info(['이미 연동되었습니다.'])
        break
      case TELEGRAM_LINK_CASE.NOT_FOUND:
        message.info(['존재하지 않는 고유 번호입니다. 텔레그램 채널에서 확인해주세요.'])
        break
      default:
        // 알 수 없는 실패에 연동 완료 팝업을 띄우지 않는다 — 보상 없이 완료로 오인된다
        message.info(['처리 중 오류가 발생했습니다.'])
    }
  }

  // 베팅 적중 알림과 이벤트 알림을 토글 1개로 통합했다 — 두 필드를 같은 값으로 함께 갱신한다
  const onChangeAlarm = async e => {
    const elem = e.target as HTMLInputElement
    await userStore.setUserGameOption({ alarmBettingHit: elem.checked, alarmNotice: elem.checked })
  }

  return (
    <TelegramContainer>
      <div className="input">
        <NumberFormat
          pattern="\d*"
          decimalScale={0}
          maxLength={50}
          allowNegative={false}
          value={userGameOptions.telegramChatId}
          onValueChange={onTelegramChatIdChange}
          placeholder="고유번호 입력"
          className="input--text"
        />
        <Button sub className="input--btn" onClick={onClickConnectTelegramBtn}>
          연동
        </Button>
      </div>

      <div className="alert">
        <span className="alert--item">
          <p className="alert--item--label">베팅 적중 및 이벤트</p>
          <input
            type="checkbox"
            id="event"
            name="eventAlarmSetting"
            /* 일괄 ON 전 과도기에는 두 필드가 어긋날 수 있어 OR 로 표시한다 */
            checked={userGameOptions.alarmBettingHit || userGameOptions.alarmNotice}
            onChange={onChangeAlarm}
            className="alert--item--switch"
          />
          <label htmlFor="event" className="on-off-wrap">
            <span className="on">ON</span>
            <span className="off">OFF</span>
          </label>
        </span>
      </div>
    </TelegramContainer>
  )
}

export default observer(Telegram)
